"use strict";

exports.__esModule = true;
exports.MapOperatorActionElement = void 0;
var _react = _interopRequireDefault(require("react"));
var _MapperDialog = require("../Dialogs/MapperDialog");
var _Timeline = require("../../Timeline");
var _useMappingProps2 = require("../Dialogs/useMappingProps");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var MapOperatorActionElement = exports.MapOperatorActionElement = function MapOperatorActionElement(props) {
  var _useMappingProps = (0, _useMappingProps2.useMappingProps)(),
    isDialogOpen = _useMappingProps.isDialogOpen,
    childProps = _useMappingProps.childProps,
    translate = _useMappingProps.translate,
    device = _useMappingProps.device,
    toggleDialog = _useMappingProps.toggleDialog;
  if (!isDialogOpen) {
    return props.children(childProps);
  }
  var label = translate("MapOperatorAction.updateMapping.label", "Map Operator");
  var partLabel = translate("MapOperatorAction.dialog.label", "Operator");
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.children(childProps), /*#__PURE__*/_react["default"].createElement(_MapperDialog.MapperDialog, {
    label: label,
    partLabel: partLabel,
    isOpen: isDialogOpen,
    toggleDialog: toggleDialog,
    partMappingInputPlaceholder: translate("MapOperatorAction.dialog.inputPlaceholder", "Enter new mapping"),
    type: "operator-value-mapping",
    device: device,
    timelineName: _Timeline.TIME_SERIES_OPERATOR
  }));
};